export default __webpack_public_path__ + "static/media/SobreNos_Sustentabilidade 1.9ffb83cb.svg";